<template>
  <FormMainContainer :title="successResponse?.title ?? $t('appointment_confirmation_page.title')">
    <div v-if="submissionFormStore.hasFormSuccess || successResponse">
      <div class="py-5 container-x-padding">
        <p
          v-for="(paragraph, index) in successResponse?.content"
          :key="index"
          v-dompurify-html="paragraph"
        ></p>

        <p v-dompurify-html="successResponse?.greetings"></p>
      </div>
    </div>
    <div class="container-x-padding">
      <button v-if="showBackButton" class="o-btn-action" type="button" @click="goHome()">
        <span>{{ $t('appointment_confirmation_page.go_home') }}</span>
      </button>
      <p v-else class="close-button" @click="close()">
        {{ $t('appointment_confirmation_page.close') }}
      </p>
    </div>
  </FormMainContainer>
</template>

<script lang="ts">
import { defineComponent, nextTick } from 'vue'
import FormMainContainer from '~concierge/components/FormMainContainer.vue'
import HeaderSection from '~concierge/components/HeaderSection.vue'
import FooterSection from '~concierge/components/FooterSection.vue'
import ContactForm from '~conciergeUiCommons/components/ContactForm.vue'
import { useAppointmentStore } from '~conciergeUiCommons/store/appointmentStore'
import { useSubmissionFormStore } from '~conciergeUiCommons/store/submissionFormStore'
import { router, usePage } from '@inertiajs/vue3'

export default defineComponent({
  components: { HeaderSection, FooterSection, ContactForm, FormMainContainer },
  setup() {
    const page = usePage()
    const appointmentStore = useAppointmentStore()
    const submissionFormStore = useSubmissionFormStore()
    const resetStore = () => {
      appointmentStore.$reset()
      submissionFormStore.$reset()
    }
    const homeUrl = page.props.homeUrl as string

    return {
      resetStore,
      submissionFormStore,
      appointmentStore,
      homeUrl
    }
  },
  props: {
    successResponse: {
      type: Object,
      required: false,
      default: null
    },
    showBackButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    formResponse() {
      return this.successResponse || this.submissionFormStore.successResponse
    }
  },
  methods: {
    async goHome(): Promise<void> {
      this.resetStore()
      await nextTick()
      router.visit(this.homeUrl)
    },
    close(): void {
      window.close()
    }
  }
})
</script>
